import { Action, SearchEmbed } from "@thoughtspot/visual-embed-sdk/react";
import { useThoughtSpotEmbedCommonProps } from "@/thoughtspot";
import { useDataSourceStore } from "@/stores/DataSourceStore";
import { useTheme } from "@/hooks/useTheme";

export function SearchEmbedPage() {
  const dataSourceId = useDataSourceStore((state) => state.searchDataSourceId);
  const { theme } = useTheme();

  const commonProps = useThoughtSpotEmbedCommonProps();

  if (!dataSourceId) {
    return null;
  }

  return (
    <SearchEmbed
      {...commonProps}
      key={`search-embed-${theme}`}
      dataSource={dataSourceId}
      dataPanelV2
      className={"w-full h-full"}
      disabledActions={[Action.ChooseDataSources]}
      hiddenActions={[
        Action.AddColumnSet,
        Action.AddQuerySet,
        Action.AddParameter,
        Action.ShowUnderlyingData,
        Action.SpotIQAnalyze,
        Action.ExportTML,
        Action.Save,
        Action.Share,
      ]}
    />
  );
}
